export default __webpack_public_path__ + "img/logo-age.png?a9aa";